import { render, staticRenderFns } from "./FilterResultRecords.vue?vue&type=template&id=77f1040c&"
import script from "./FilterResultRecords.vue?vue&type=script&lang=js&"
export * from "./FilterResultRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports